/**
 * Shop sale / collection cards: sync price + main image when a bed size is selected.
 */
(function () {
  function closestCard(btn) {
    return btn.closest('.sleepys-shop-sale-card') || btn.closest('.sleepys-product-card');
  }

  function updatePriceFromButton(card, btn) {
    var slot = card.querySelector('.sleepys-card-price-slot');
    if (!slot) return;

    var priceRoot = slot.querySelector('.price');
    if (!priceRoot) return;

    /**
     * Dawn component-price.css: when .price--on-sale, .price__regular is display:none and the
     * visible current price is .price__sale .price-item--last. custom-price.liquid puts
     * sleepys-card-price-current inside .price__regular — updating only that node leaves the
     * on-screen sale price stale (wrong variant $ on any compare-at / sale variant).
     */
    var regular =
      priceRoot.querySelector('.sleepys-card-price-current') ||
      priceRoot.querySelector('.price__regular span.price-item--regular') ||
      priceRoot.querySelector('.price__regular .price-item--regular:not(s)');
    var saleLine =
      priceRoot.querySelector('.price__sale .price-item--sale.price-item--last') ||
      priceRoot.querySelector('.price__sale .price-item--last');
    var strike = priceRoot.querySelector('.price__compare strike');
    var onSale = btn.getAttribute('data-on-sale') === '1';
    var money = btn.getAttribute('data-money') || '';
    var compare = btn.getAttribute('data-compare') || '';
    var showCompare = Boolean(onSale && compare);

    if (regular) regular.textContent = money;
    if (saleLine) saleLine.textContent = money;

    if (strike) {
      if (showCompare) {
        strike.textContent = compare;
        strike.classList.remove('!tw-hidden');
      } else {
        strike.textContent = '';
        strike.classList.add('!tw-hidden');
      }
    }
    priceRoot.classList.toggle('price--on-sale', showCompare);
  }

  function updateSaleChromeFromButton(card, btn) {
    var onSale = btn.getAttribute('data-on-sale') === '1';
    var compare = (btn.getAttribute('data-compare') || '').trim();
    var hasCompare = onSale && compare.length > 0;

    var slot = card.querySelector('.sleepys-card-price-slot');
    if (slot) {
      slot.classList.toggle('sleepys-card-price-slot--has-compare', hasCompare);
    }

    var ribbon = card.querySelector('.sleepys-sale-card__ribbon');
    if (ribbon) {
      ribbon.hidden = !hasCompare;
    }
  }

  function updateImageFromButton(card, btn) {
    var url = btn.getAttribute('data-img');
    if (!url) return;
    var img = card.querySelector('.sleepys-card-product-image');
    if (!img) return;
    img.src = url;
    img.removeAttribute('srcset');
  }

  function setSelectedState(card, activeBtn) {
    card.querySelectorAll('.sleepys-card-size-btn').forEach(function (b) {
      b.setAttribute('aria-selected', b === activeBtn ? 'true' : 'false');
    });
  }

  function appendVariantToUrl(href, variantId) {
    if (!href || !variantId) return href;
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      return url.pathname + url.search + url.hash;
    } catch (err) {
      return href;
    }
  }

  function updateProductLinksFromButton(card, btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var links = card.querySelectorAll('.sleepys-sale-card__media-link, .sleepys-sale-card__title a');
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      link.setAttribute('href', appendVariantToUrl(href, variantId));
    });
  }

  /** Align price row + media + links with the size pill that has aria-selected (server truth). */
  function syncCardFromSelectedSize(card) {
    var btn = card.querySelector('.sleepys-card-size-btn[aria-selected="true"]');
    if (!btn) return;
    updatePriceFromButton(card, btn);
    updateSaleChromeFromButton(card, btn);
    updateImageFromButton(card, btn);
    updateProductLinksFromButton(card, btn);
  }

  function initSaleCards(root) {
    var scope = root || document;
    scope.querySelectorAll('.sleepys-shop-sale-card').forEach(syncCardFromSelectedSize);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSaleCards(document);
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) {
      initSaleCards(ev.target);
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sleepys-card-size-btn');
    if (!btn) return;

    var card = closestCard(btn);
    if (!card) return;

    e.preventDefault();
    setSelectedState(card, btn);
    updatePriceFromButton(card, btn);
    updateSaleChromeFromButton(card, btn);
    updateImageFromButton(card, btn);
    updateProductLinksFromButton(card, btn);
  });
})();
